'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { createField } from './createField.js';
import { createForm } from './createForm.js';
import { createStore } from './store.js';
/**
 * Creates a form api that can be used to manage form data.
 *
 * @param root0 hook args
 * @param root0.mutationApi Mutation api from core-framework
 * @param root0.defaultValues Default values of form fields, used to get type safe fields
 * @returns Forms API for managing form data
 */
export function useForm(t0) {
  const $ = _c(3);
  const {
    defaultValues,
    mutationApi
  } = t0;
  let t1;
  if ($[0] !== defaultValues || $[1] !== mutationApi) {
    t1 = () => {
      const store = createStore(defaultValues);
      const Form = createForm({
        store,
        mutationApi
      });
      const Field = createField({
        store
      });
      return {
        store,
        Form,
        Field
      };
    };
    $[0] = defaultValues;
    $[1] = mutationApi;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [formApi] = useState(t1);
  return formApi;
}